import { ApplicationState } from '@app/store'
import { IGlobalConfigurationState, IGlobalHbUserState, selectConfiguration, selectHbContacts } from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import PipelineListPage from '../components/PipelineListPage'
import {
  actionCreators,
  IPipelineListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectListingtype,
  selectOrderBy,
  selectScope,
  selectSellingAgent,
  selectSortOrder,
  selectStatus,
  selectTotalItems,
  selectTotalPotentialProfit,
  selectYear,
} from '../modules/pipelineList'

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IPipelineListState & IGlobalConfigurationState & IGlobalHbUserState>({
      configuration: selectConfiguration(),
      error: selectError(),
      filterText: selectFilterText(),
      hbContacts: selectHbContacts(),
      isLoading: selectIsLoading(),
      items: selectItems(),
      listingType: selectListingtype(),
      scope: selectScope(),
      sellingAgent: selectSellingAgent(),
      sortOrder: selectSortOrder(),
      orderBy: selectOrderBy(),
      status: selectStatus(),
      totalItems: selectTotalItems(),
      totalPotentialProfit: selectTotalPotentialProfit(),
      year: selectYear(),
    }),
    actionCreators
  )(PipelineListPage)
)
